import { Reporte } from "../../components/Reporte"

export const ClienteRepPjBVG = () => {
    return (
        <Reporte url="reporte/buscar-pj-bvg" uindex="ficha/reporte-index-clientepj" nameReport="reporte-pj.xlsx" esBvg={true} />
    )
}
